import getClient from './getClient'

interface SignInProps {
  email: string
}

export default function signIn({ email }: SignInProps) {
  return getClient().auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser: false,
    },
  })
}
